export function emitError(global, id, eventTitle) {
  var _mz = global._mz,
      _mze = global._mze;
  if (!_mz || !_mze) return;

  _mz.emit(_mze.ERROR, {
    id: id,
    eventTitle: eventTitle
  });
}
export function emitResourceDisplayModal(global, name) {
  var _mz = global._mz,
      _mze = global._mze;
  if (!_mz || !_mze) return;

  _mz.emit(_mze.DISPLAY, {
    module: {
      type: 'resource-modal',
      name: name
    }
  }); // eslint-disable-next-line no-underscore-dangle


  if (_mz.registerAutoHandlers) _mz.registerAutoHandlers(_mz, _mz.environment);
}
export function emitRelatedResourcesDisplay(global, name, relatedResources) {
  var _mz = global._mz,
      _mze = global._mze;
  if (!_mz || !_mze) return;
  var paidResources = relatedResources.filter(function (doc) {
    return doc.licence === 'Paid';
  }).length;
  var freeResources = relatedResources.length - paidResources; // eslint-disable-next-line no-underscore-dangle

  _mz.emit(_mze.DISPLAY, {
    module: {
      type: 'related-resources',
      name: name
    },
    payload: {
      paidShown: paidResources,
      freeShown: freeResources,
      resourcesShown: relatedResources.map(function (doc) {
        return doc.id;
      })
    }
  }); // eslint-disable-next-line no-underscore-dangle


  if (_mz.registerAutoHandlers) _mz.registerAutoHandlers(_mz, _mz.environment);
}
export function emitRecommendedResourcesDisplay(global, name, recommendedResources) {
  var _mz = global._mz,
      _mze = global._mze;
  if (!_mz || !_mze) return; // eslint-disable-next-line no-underscore-dangle

  _mz.emit(_mze.DISPLAY, {
    module: {
      type: 'recommended-resources',
      name: name
    },
    payload: {
      resourcesShown: recommendedResources.map(function (doc) {
        return doc.id;
      })
    }
  }); // eslint-disable-next-line no-underscore-dangle


  if (_mz.registerAutoHandlers) _mz.registerAutoHandlers(_mz, _mz.environment);
}
export function emitClick(global, type, name) {
  var _mz = global._mz,
      _mze = global._mze;
  if (!_mz || !_mze) return;

  _mz.emit(_mze.CLICK, {
    module: {
      type: type,
      name: name
    }
  }); // eslint-disable-next-line no-underscore-dangle


  if (_mz.registerAutoHandlers) _mz.registerAutoHandlers(_mz, _mz.environment);
}